"use client"

import { QueryClient } from "@tanstack/react-query"
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister"

// Module singleton (not per-component) so the persister has a stable client and
// logout can reach it to purge the previous member's cached data. Safe here
// because every query is client-only (`enabled` on client state, fetched from
// the cross-origin Laravel host) — nothing prefetches on the server, so there's
// no cross-request leakage.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      // Must be >= the persister's maxAge or entries get gc'd before restore.
      gcTime: 1000 * 60 * 60 * 24, // 24h
    },
  },
})

// localStorage key holding the dehydrated cache. Cleared on logout alongside
// psc-auth and the SW's clear-api-cache, so the next member on this device
// can't see the previous member's membership / bookings flash on reopen.
export const QUERY_CACHE_KEY = "psc-query-cache"

export const queryPersister = createSyncStoragePersister({
  storage: typeof window !== "undefined" ? window.localStorage : undefined,
  key: QUERY_CACHE_KEY,
})

/** Drop both the in-memory and persisted query cache. Call on sign-out / 401. */
export function purgeQueryCache() {
  queryClient.clear()
  void queryPersister.removeClient()
}
